import { TEAM_COLOURS } from "./data";
import styles from "./ColourPicker.module.css";

export default function ColourPicker({ value, onChange }) {
  return (
    <div className={styles.picker}>
      {TEAM_COLOURS.map((colour) => (
        <button
          key={colour}
          type="button"
          aria-label={`Select colour ${colour}`}
          className={`${styles.swatch} ${value === colour ? styles.selected : ""}`}
          style={{ background: colour }}
          onClick={() => onChange(colour)}
        />
      ))}
    </div>
  );
}
